/* Page eventos scripts
========================================================================== */

if (jQuery('#contenedor-eventos').length !== 0) {
	// Delegación de eventos para manejar clics en los elementos dinámicos
	document.addEventListener('click', function(event) {
		// Buscar el elemento más cercano con la clase "barra-superior-contenido-item"
		let item = event.target.closest('.barra-superior-contenido-item');
		if (!item) return; // Si no se encontró el elemento, salir

		mostrar_contenido_item_acordeon(item);
	});

	// Función que gestiona la apertura/cierre de los items
	function mostrar_contenido_item_acordeon(element) {
		// Verificar que el elemento tiene hijos antes de acceder a `lastElementChild`
		if (!element || !element.lastElementChild) return;

		// Si el elemento ya está abierto, lo cerramos
		if (element.lastElementChild.classList.contains('abierto')) {
			if (element.nextElementSibling) {
				element.nextElementSibling.classList.add('ocultar-contenido-item');
			}
			element.lastElementChild.classList.remove('abierto'); // El signo de la derecha
			return;
		}

		// Cerrar todos los elementos abiertos
		let barras_superiores_contenidos_items = document.querySelectorAll('.barra-superior-contenido-item');
		barras_superiores_contenidos_items.forEach(item => {
			if (item.nextElementSibling) {
				item.nextElementSibling.classList.add('ocultar-contenido-item');
			}
			if (item.lastElementChild) {
				item.lastElementChild.classList.remove('abierto'); // El signo de la derecha
			}
		});

		// Abrir el item seleccionado
		if (element.nextElementSibling) {
			element.nextElementSibling.classList.toggle('ocultar-contenido-item');
		}
		element.lastElementChild.classList.toggle('abierto'); // El signo de la derecha
	}

	// Manejar el cierre con la tecla Escape
	document.addEventListener('keydown', function(event) {
		if (event.key === "Escape") {
			let pantallas_modales = document.querySelectorAll('.pantalla-modal');
			pantallas_modales.forEach(modal => {
				modal.classList.remove('pantalla-modal');
			});
		}
	});

	// Delegación de eventos para el botón de "Load More"
	document.addEventListener('click', function(event) {
		let btnLoadMore = event.target.closest('.load-more-content');
		if (!btnLoadMore) return; // Si no se hace clic en el botón, salir

		var hidden_class = 'ocultar-contenido-items';
		var contenido = btnLoadMore.parentNode.querySelector('.contenido-items');

		if (contenido && contenido.classList.contains(hidden_class)) {
			btnLoadMore.classList.add('abierto');
			contenido.classList.remove(hidden_class);
		} else if (contenido) {
			btnLoadMore.classList.remove('abierto');
			contenido.classList.add(hidden_class);
		}
	});
}
